import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

export async function getPlageTimeUserDD(idUser:number, datFrom:string, datTo:string, idCentre:number|null):Promise<PlageTime[]>{
    let params = `idUser=${idUser}&datFrom=${datFrom}&datTo=${datTo}`
    if(idCentre){
        params+=`&Centre=${idCentre}`
    }
    const res:any = await dataFetcher(`plage_times?${params}`, {method:'get'})
    return res["hydra:member"]
}